import React, { useCallback, useEffect, useState, useRef } from 'react';
import './stocksummary.css';
import { useLocation, useNavigate, useNavigation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Stock_Summary_Help from '../../../components/help/stock_summary/Stock_Summary_Help';
import Period from '../../../components/help/stock_summary/stock_summary_component/Period';
import Configure from '../../../components/help/stock_summary/stock_summary_component/Configure';
import Company from '../../../components/help/stock_summary/stock_summary_component/Company';
import Stock_Group from '../../../components/help/stock_summary/stock_summary_component/Stock_Group';
import BasicValue from '../../../components/help/stock_summary/stock_summary_component/BasicValue';
import ChangeView from '../../../components/help/stock_summary/stock_summary_component/ChangeView';
import ExceptionReports from '../../../components/help/stock_summary/stock_summary_component/ExceptionReports';
import SaveView from '../../../components/help/stock_summary/stock_summary_component/SaveView';
import Valuation from '../../../components/help/stock_summary/stock_summary_component/Valuation';
import SummaryType from '../../../components/help/stock_summary/stock_summary_component/SummaryType';
import { closeModal, openModal, stockSummaryList } from '../../../redux/actions/action-creator';
import { dateFormateSend, dateFormateShow, currencyFormate } from '../../../components/Date_Formate_Utilitiy/Index';
import GodownFilter from '../../../components/help/stock_summary/stock_summary_component/GodownFilter';
import Stock_Category from '../../../components/help/stock_summary/stock_summary_component/Stock_Category';
import StockItemSummaryFooter from '../../../components/Footer/StockItemSummaryFooter';
import { useDropdownScroll } from '../../../components/Custom_Hooks/useDropdownScroll';
import { stockData } from './stockData';
import { useDropdownKeyboardNavigation } from '../../../components/Custom_Hooks/useDropdownKeyboardNavigation';
import Indicator from '../../../components/Indicator/Indicator';

const StockSummary = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData = null } = useSelector(state => state.auth);
  const { company_session } = useSelector(state => state.common);
  const modal_state = useSelector(state => state.common.modal_state);

  const [date, setDate] = useState({
    show_from_date: dateFormateShow(company_session?.start_financial_year),
    show_to_date: dateFormateShow(company_session?.current_date),
    send_from_date: company_session?.start_financial_year,
    send_to_date: company_session?.current_date,
    location_id: '',
    stock_category_id: '',
    stock_group_id: '',
    stock_company_id: '',
    filter_name: 'Item-Wise',
    name_nav: `Primary`,
  })
  const [state_configure, setState_configure] = useState(
    {
      show_quantity: 'No',
      show_alternate_unit: 'No',
      show_tail_unit_of_compound_unit: 'No',
      show_rate: 'No',
      show_value: 'No',
      show_opening_balance: 'No',
      show_goods_inwards: 'No',
      show_goods_outwards: 'No',
      show_gross_value_of_outwards: 'No',
      show_comsumption_and_gross_profit: 'No',
      show_gross_profits_on_gross_value: 'No',
      show_closing_balance: 'No',
      show_stock_item_with_zero_qty_or_blc: 'No',
      exclude_detail_with_no_transaction: 'No',
      type_of_grouping: '',
      formate_of_report: 'Condensed',
      expand_all_level_in_details_formate: 'No',
      display_name: 'Name Only',
      sorting_method: 'Default',
    })

  const [removedItems, setRemovedItems] = useState([])
  const [data, setData] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)
  const [selectedItem, setSelectedItem] = useState(0)
  const [selectedItems, setSelectedItems] = useState([]);
  const [f4Enable, setF4Enable] = useState(false);
  const boxRef = useRef(null)

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true);
  //       setRawData(stockData);
  //     } catch (error) {
  //       setRawData([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchData();
  // }, [date])


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append('fromDate', dateFormateSend(date.send_from_date));
        formData.append('toDate', dateFormateSend(date.send_to_date));
        formData.append('company_id', userData.id);
        formData.append('location_id', date.location_id);
        formData.append('stock_cat_id', date.stock_category_id);
        formData.append('stock_gp_id', date.stock_group_id);
        formData.append('stock_company_id', date.stock_company_id);
        const response = await dispatch(stockSummaryList(formData));
        if (response && response.status) {
          setRawData(response.data);
          // setRawData(stockData);
        } else {
          // setRawData(response.data);
          setRawData(stockData);
        }
      } catch (error) {
        setRawData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [date])

  const filterDataCoonfigure = useCallback(() => {
    const newData = rawData?.map(item => {
      const godownData = item?.godown_data;
      return state_configure?.formate_of_report === 'Condensed' ? [item] : [item, ...godownData]
    }).flat();
    setData(newData)
  }, [state_configure, rawData])

  useEffect(() => {
    filterDataCoonfigure();
  }, [filterDataCoonfigure]);

  const detailFormate = useCallback((e) => {
    if ((e.altKey && e.key === 'F1') || (e.altKey && e.key === 'F5')) {
      e.preventDefault();
      setState_configure(prevState => ({
        ...prevState,
        formate_of_report: prevState.formate_of_report === 'Condensed' ? 'Detailed' : 'Condensed'
      }));
    }
  }, [state_configure])

  useEffect(() => {
    window.addEventListener('keydown', detailFormate);
    return () => {
      window.removeEventListener('keydown', detailFormate);
    };

  }, [detailFormate])

  const { selectedItemIndex, setSelectedItemIndex } =
    useDropdownKeyboardNavigation({
      items: data,
      state:
        modal_state?.period ||
          modal_state?.stockGroup ||
          modal_state?.godownWise ||
          modal_state?.stockCate ||
          modal_state?.stockCompany ||
          modal_state?.configure ||
          modal_state?.delete ||
          modal_state?.basic ||
          modal_state?.changeView ||
          modal_state?.exceptionReports ||
          modal_state?.saveView ||
          modal_state?.valuation ||
          modal_state?.period ||
          modal_state?.configure ||
          modal_state?.valuation ||
          modal_state?.summaryType ||
          modal_state?.periodType ||
          modal_state?.applyFilter ||
          modal_state?.share ||
          modal_state?.print ||
          modal_state?.detailedCondensed ||
          modal_state?.period
          ? false
          : true,
      onItemSelect: (item) => {
        // navigate(`../stock_item_voucher/${item?.stock_item_id}`);
        navigate(`../stock_item_voucher/${item.grandOpeningData.stock_item_id}`)
      },
      onItemSpaceSelect: (item) => {
        toggleSelection(selectedItemIndex);
      },
      onItemAltRSelect: (item) => {
        removeSelectedItems();
      },
      onItemAltUSelect: (item) => {
        restoreSelectedItems();
      },
      onItemF1Select: (item) => {
        setLoading(true);
        dispatch(openModal("detailedCondensed"));
      },
      onItemF2Select: (item) => {
        setLoading(true);
        dispatch(openModal("period"));
      },
      onItemF3Select: (item) => {
        // setLoading(true);
        // dispatch(openModal("stockGroup"));
      },
      onItemF4Select: (item) => {
        setLoading(true);
        const filter = date.filter_name;
        if (filter === 'Group-Wise') {
          dispatch(openModal("stockGroup"));
        } else if (filter === 'Category-Wise') {
          dispatch(openModal("stockCate"));
        } else if (filter === 'Company-Wise') {
          dispatch(openModal("stockCompany"));
        } else {
          setF4Enable(false);
          setLoading(false);
        }
      },
      onItemF5Select: (item) => {
        setLoading(true);
        dispatch(openModal("summaryType"));
      },
      onItemF6Select: (item) => {
        setLoading(true);
        dispatch(openModal("periodType"));
      },
      onItemF7Select: (item) => {
        setLoading(true);
        dispatch(openModal("godownWise"));
      },
      onItemAltFSelect: (item) => {
        setLoading(true);
        dispatch(openModal("applyFilter"));
      },
      onItemSSelect: (item) => {
        setLoading(true);
        dispatch(openModal("share"));
      },
      onItemPSelect: (item) => {
        setLoading(true);
        dispatch(openModal("print"));
      },
      onItemF12Select: (item) => {
        setLoading(true);
        dispatch(openModal("configure"));
      },

    });
  useEffect(() => {
    const filter = date.filter_name;
    if (filter === 'Group-Wise' || filter === 'Category-Wise' || filter === 'Company-Wise') {
      setF4Enable(true);
    } else {
      setF4Enable(false);
    }
  }, [f4Enable, date.filter_name]);

  useDropdownScroll({ dropdownRef: boxRef, selectedItemIndex });
  // Function to toggle selection of an item
  const toggleSelection = (index) => {
    const selectedIndex = selectedItems.indexOf(index);
    let newSelected = [];
    if (selectedIndex === -1) {
      // Add the item to the selection if not already selected
      newSelected = newSelected.concat(selectedItems, index);
    } else if (selectedIndex === 0) {
      // Remove the item from the selection if already selected
      newSelected = newSelected.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelected = newSelected.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }
    setSelectedItems(newSelected);
  };

  // Function to remove selected items
  const removeSelectedItems = () => {
    // If multiple items are selected, remove all selected items
    if (selectedItems.length > 0) {
      const selectedIndices = [...selectedItems].sort((a, b) => a - b); // Sort in ascending order
      const removedItemsList = [];

      // Collect all items to be removed
      selectedIndices.forEach(index => {
        removedItemsList.push({
          index: index,
          item: data[index]
        });
      });

      // Filter out selected items from the list
      const updatedData = data?.filter((_, index) => {
        return !selectedIndices.includes(index);
      });

      // Recalculate totals
      // let current_debit_total_amount = 0;
      // let current_credit_total_amount = 0;
      // updatedData.forEach((item) => {
      //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
      //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      // });

      // setState({
      //   ...state,
      //   total_credit_amount: current_credit_total_amount,
      //   total_debit_amount: current_debit_total_amount,
      // });
      setData(updatedData);
      setRemovedItems([...removedItems, ...removedItemsList]);
      setSelectedItems([]); // Clear selection after removal
    } else {
      // If no multi-selection, remove single selected item
      const updatedData = data?.filter((_, index) => {
        return index !== selectedItemIndex;
      });

      const removedItem = data[selectedItemIndex];

      // let current_debit_total_amount = 0;
      // let current_credit_total_amount = 0;
      // updatedData.forEach((item) => {
      //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
      //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
      // });

      // setState({
      //   ...state,
      //   total_credit_amount: current_credit_total_amount,
      //   total_debit_amount: current_debit_total_amount,
      // });
      setData(updatedData);
      setRemovedItems([
        ...removedItems,
        { index: selectedItemIndex, item: removedItem },
      ]);
    }
  };

  // Function to restore selected items
  const restoreSelectedItems = () => {
    if (removedItems.length === 0) {
      return; // No items to restore
    }

    // Restore the last removed item (LIFO - Last In, First Out)
    const lastRemovedItem = removedItems[removedItems.length - 1];
    const { index: originalIndex, item } = lastRemovedItem;

    // Find the correct position to insert the item back
    // We need to count how many items were removed before this one
    let insertIndex = originalIndex;
    const itemsRemovedBefore = removedItems.filter(removedItem =>
      removedItem.index < originalIndex
    ).length;

    // Adjust the insert index based on how many items were removed before this one
    insertIndex = originalIndex - itemsRemovedBefore;

    // Create updated voucher entry list with the restored item at the correct position
    const updatedData = [
      ...data?.slice(0, insertIndex),
      item,
      ...data?.slice(insertIndex),
    ];

    /* const updatedData = {
      ...data,
      updatedData,
    }; */

    // Recalculate totals
    // let current_debit_total_amount = 0;
    // let current_credit_total_amount = 0;
    // updatedVoucherEntryList.forEach((item) => {
    //   current_debit_total_amount += parseFloat(item?.total_debit_amount || 0);
    //   current_credit_total_amount += parseFloat(item?.total_credit_amount || 0);
    // });

    // setState({
    //   ...state,
    //   total_credit_amount: current_credit_total_amount,
    //   total_debit_amount: current_debit_total_amount,
    // });
    setData(updatedData);

    // Set the restored item as the selected item to show visual indication
    setSelectedItem(insertIndex);

    // Remove the restored item from removedItems array
    setRemovedItems(removedItems.slice(0, -1));
  };



  let total_opnening_quantity = 0;
  let total_inwards_quantity = 0;
  let total_outwards_quantity = 0;
  let total_closing_quantity = 0;
  let total_opening_value = 0;
  let total_inwards_value = 0;
  let total_outwards_value = 0;
  let total_closing_value = 0;
  let unit_name = ''
  return (
    <div className='section'>
      <div className='detail'>
        {
          modal_state.period ?
            <Period
              setDate={setDate}
              date={date}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockGroup ?
            <Stock_Group
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.godownWise ?
            <GodownFilter
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockCate ?
            <Stock_Category
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.stockCompany ?
            <Company
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.configure ?
            <Configure
              setState_configure={setState_configure}
              setLoading={setLoading}
            /> : null
        }
        {
          modal_state.basic ? <BasicValue setLoading={setLoading} /> : null
        }
        {
          modal_state.changeView ? <ChangeView setLoading={setLoading} /> : null
        }
        {
          modal_state.exceptionReports ? <ExceptionReports setLoading={setLoading} /> : null
        }
        {
          modal_state.saveView ? <SaveView setLoading={setLoading} /> : null
        }
        {
          modal_state.valuation ? <Valuation setLoading={setLoading} /> : null
        }
        {
          modal_state.summaryType ?
            <SummaryType
              date={date}
              setDate={setDate}
              setLoading={setLoading}
            /> : null
        }
        <div className='container-fluid' id='reletive' style={{ height: '90vh' }}>
          <div className='row border_2_1px table_date_header' >
            <div className='col-12  d-flex justify-content-between  table_header_font'>
              Stock Summary : {date?.filter_name} {date?.name_nav ? '(Godown: ' : null} {date?.name_nav}{date?.name_nav ? ')' : null}
              <span>  {`${date?.show_from_date} To ${date?.show_to_date} `}</span>
            </div>
          </div>
          <div className='row border_2_1px_bottom' style={{ height: 40 }}>
            <div className='col-2 border_2_1px_right border_2_1px_left  d-flex justify-content-start align-items-center table_header_font'>
              <b style={{ wordSpacing: '30px' }}> Particular </b>
            </div>
            <div className='col-10 m-0 p-0'>
              <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                <div className='col-3 d-flex flex-column  border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Opening Balance</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '25%' }}>
                      Quantity
                    </div>
                    <div className='col-3 table_header_font p-0 m-0 text-end' style={{ width: '37.45%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '37.45%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Inwards</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '25%' }}>
                      Quantity
                    </div>
                    <div className='col-3 table_header_font text-end p-0 m-0' style={{ width: '37.45%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '37.45%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Outwards</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '25%' }}>
                      Quantity
                    </div>
                    <div className='col-3 m-0 p-0 text-end table_header_font' style={{ width: '37.45%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '37.45%' }}>
                      Value
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0 table_header_font' style={{ width: '25%' }}>
                  <b>Closing Balance</b>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_header_font' style={{ width: '25%' }}>
                      Quantity
                    </div>
                    <div className='col-3 p-0 m-0 text-end table_header_font' style={{ width: '37.45%' }}>
                      Rate
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_header_font' style={{ width: '37.45%' }}>
                      Value
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={` row  border_2_1px_bottom postion-relative`} style={{ height: '76.5vh' }} >
            <div className='col-2 border_2_1px_right border_2_1px_left text-start table_body_font' style={{ height: '76.5vh' }} >
            </div>
            <div className='col-10 m-0 p-0' style={{ height: '76.5vh' }}>
              <div className='row m-0 p-0 ' style={{ width: '100%', height: '76.5vh' }}>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '25%', overflow: 'hidden', wordSpacing: -4, whiteSpace: 'nowrap' }}>
                    </div>
                    <div className='col-3 m-0 p-0 text-end table_body_font' style={{ width: '37.45%', overflow: 'hidden', }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -16 }}>
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '25%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '25%' }}>
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '25%' }}>
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%' }}>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row m-0 p-0' style={{ position: 'absolute', width: '100%', height: '76.5vh', overflowY: 'auto', overflowX: 'hidden' }} ref={boxRef}>
              <div className='col-12'>
                {
                  loading ?
                    <div className='col-12 d-flex align-items-center justify-content-center' style={{ height: '70vh' }}>
                      <Indicator />
                    </div> :
                    data?.map((item, index) => {
                      total_opening_value += parseFloat(item?.stock_item ? item?.grandOpeningData?.value : 0)
                      total_inwards_value += parseFloat(item?.stock_item ? item?.grandInwardData?.value : 0)
                      total_outwards_value += parseFloat(item?.stock_item ? item?.grandOutwardData?.value : 0)
                      total_closing_value += parseFloat(item?.stock_item ? item?.grandClosingData?.value : 0)
                      const parts = item?.grandOpeningData?.quantity?.split(' ');
                      const parts_1 = item?.grandInwardData?.quantity?.split(' ');
                      const parts_2 = item?.grandOutwardData?.quantity?.split(' ');
                      const parts_3 = item?.grandClosingData?.quantity?.split(' ');
                      // unit_name = parts[1]
                      // unit_name = 'Nos'
                      const unit_name = parts && parts.length > 1 ? parts[1] : '';
                      total_opnening_quantity += parseFloat(item?.stock_item && parts ? parts[0] : 0)
                      total_inwards_quantity += parseFloat(item?.stock_item && parts_1 ? parts_1[0] : 0)
                      total_outwards_quantity += parseFloat(item?.stock_item && parts_2 ? parts_2[0] : 0)
                      total_closing_quantity += parseFloat(item?.stock_item && parts_3 ? parts_3[0] : 0)
                      return (
                        <div
                          style={{ cursor: 'pointer' }}
                          key={index}
                          className={`${selectedItems.includes(index) ? 'selected_multi' : ''}`}
                          onClick={() => setSelectedItemIndex(index)}
                          onDoubleClick={() => navigate(`../stock_item_voucher/${item?.grandOpeningData?.stock_item_id}`)}
                        >
                          <div className={`row ${index === selectedItemIndex ? selectedItems.includes(index) ? 'selected_multi_selected' : 'selected' : ''}`} >
                            <div className={`col-2  text-start table_body_font ${item?.stock_item ? 'ps-1' : ''}`}>
                              {item?.stock_item?.item_name} {item?.location_name}
                            </div>
                            <div className='col-10 m-0 p-0'>
                              <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                                    <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '25%', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                      {parseFloat(item?.grandOpeningData?.quantity) > 0 ? item?.grandOpeningData?.quantity : null}
                                    </div>
                                    <div className='col-3 m-0 p-0  text-end table_body_font' style={{ width: '37.45%', overflow: 'hidden', }}>
                                      {item?.grandOpeningData?.rate > 0 ? currencyFormate(item?.grandOpeningData?.rate) : null}
                                    </div>
                                    <div className='col-3 text-end p-0 m-0 pe-1 table_body_font' style={{ width: '37.45%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -7 }}>
                                      {item?.grandOpeningData?.value > 0 ? currencyFormate(item?.grandOpeningData?.value) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                                    <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '25%' }}>
                                      {parseFloat(item?.grandInwardData?.quantity) > 0 ? item?.grandInwardData?.quantity : null}
                                    </div>
                                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandInwardData?.rate > 0 ? currencyFormate(item?.grandInwardData?.rate) : null}
                                    </div>
                                    <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandInwardData?.value > 0 ? currencyFormate(item?.grandInwardData?.value) : null}
                                    </div>
                                  </div>
                                </div>
                                <div className='col-3 border_2_1px_right text-nowrap  m-0 p-0' style={{ width: '25%' }}>
                                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                                    <div className='col-3 text-end p-0 m-0 table_body_font' style={{ width: '25%' }}>
                                      {parseFloat(item?.grandOutwardData?.quantity) > 0 ? item?.grandOutwardData?.quantity : null}
                                    </div>
                                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandOutwardData?.rate > 0 ? currencyFormate(item?.grandOutwardData?.rate) : null}
                                    </div>
                                    <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandOutwardData?.value > 0 ? currencyFormate(item?.grandOutwardData?.value) : null}                                    </div>
                                  </div>
                                </div>
                                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                                    <div className='col-3 text-end text-nowrap p-0 m-0 table_body_font' style={{ width: '25%' }}>
                                      {parseFloat(item?.grandClosingData?.quantity) > 0 ? item?.grandClosingData?.quantity : null}
                                    </div>
                                    <div className='col-3 text-end m-0 p-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandClosingData?.rate > 0 ? currencyFormate(item?.grandClosingData?.rate) : null}
                                    </div>
                                    <div className='col-3 text-end p-0 pe-1 m-0 table_body_font' style={{ width: '37.45%' }}>
                                      {item?.grandClosingData?.value > 0 ? currencyFormate(item?.grandClosingData?.value) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    })
                }

              </div>
            </div>
          </div>


          <div className={`row border_2_1px_bottom ${data?.length > 0 ? 'border-top-0' : ''}`}>
            <div className='col-2 border_2_1px_right text-start table_footer_font'>
              Grand Total
            </div>
            <div className='col-10 m-0 p-0'>
              <div className='row m-0 p-0 ' style={{ width: '100%' }}>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3 text-end p-0 m-0 table_footer_font' style={{ width: '25%', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                      {`${total_opnening_quantity == 0 ? '' : total_opnening_quantity} ${unit_name}`}
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_footer_font' style={{ width: '37.45%', overflow: 'hidden', }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '37.45%', overflow: 'hidden', whiteSpace: 'nowrap', wordSpacing: -7 }}>

                      {
                        total_opening_value == 0 ? '' :
                          total_opening_value?.toFixed(userData?.no_of_decimal_place)}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '25%' }}>
                      {`${total_inwards_quantity == 0 ? '' : total_inwards_quantity} ${unit_name}`}
                    </div>
                    <div className='col-3  text-end table_footer_font p-0 m-0' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '37.45%' }}>
                      {
                        total_inwards_value == 0 ? '' :
                          total_inwards_value?.toFixed(userData?.no_of_decimal_place)}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '25%' }}>
                      {`${total_outwards_quantity == 0 ? '' : total_outwards_quantity} ${unit_name}`}
                    </div>
                    <div className='col-3  text-end m-0 p-0 table_footer_font' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '37.45%' }}>
                      {
                        total_outwards_value == 0 ? '' :
                          total_outwards_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
                <div className='col-3 border_2_1px_right m-0 p-0' style={{ width: '25%' }}>
                  <div className='row m-0 p-0' style={{ width: '100%' }}>
                    <div className='col-3  text-end p-0 m-0 table_footer_font' style={{ width: '25%' }}>
                      {`${total_closing_quantity == 0 ? '' : total_closing_quantity} ${unit_name}`}
                    </div>
                    <div className='col-3 text-end m-0 p-0 table_footer_font' style={{ width: '37.45%' }}>
                    </div>
                    <div className='col-3 text-end p-0 pe-1 m-0 table_footer_font' style={{ width: '37.45%' }}>
                      {
                        total_closing_value == 0 ? '' :
                          total_closing_value?.toFixed(userData?.no_of_decimal_place).replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <StockItemSummaryFooter
          isDisable={removedItems.length === 0}
          spaceFunction={() => toggleSelection(selectedItemIndex)}
          removeLineFunction={() => removeSelectedItems()}
          restoreLineFunction={() => restoreSelectedItems()}
        />
      </div>
      <div className='help border_1_1px_left backgroud_color_1 position-relative'>
        {modal_state.period || modal_state.godownWise || modal_state.stockCate || modal_state.stockCompany || modal_state.stockGroup || modal_state.basic || modal_state.changeView || modal_state.exceptionReports || modal_state.saveView || modal_state.valuation || modal_state.summaryType ? null :
          <Stock_Summary_Help date={date} f4Enable={f4Enable} />
        }
      </div>
    </div>
  )
}

export default StockSummary
